import { render, staticRenderFns } from "./popup-process.vue?vue&type=template&id=56e397ac&scoped=true"
import script from "./popup-process.vue?vue&type=script&lang=js"
export * from "./popup-process.vue?vue&type=script&lang=js"
import style0 from "./popup-process.vue?vue&type=style&index=0&id=56e397ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e397ac",
  null
  
)

export default component.exports